<div class="barn-item spacing--padding-all spacing--margin-all" data-test="barn-item">
  <form [formGroup]="barnForm" [agrConnectForm]="barn$" (ngSubmit)="save()">
    <div class="flex--column">
      <mat-form-field class="flex__child--auto">
        <input
          matInput
          placeholder="{{ 'barn-item.name' | translate }}"
          formControlName="name"
          data-test="barn-item__name"
        />
        <mat-error
          *ngIf="!!barnForm.controls.name.errors && barnForm.controls.name.errors.duplicateBarnName"
        >
          {{ 'barn-item.error-name-duplicate' | translate }}
        </mat-error>
        <mat-error
          *ngIf="!!barnForm.controls.name.errors && barnForm.controls.name.errors.required"
        >
          {{ 'barn-item.error-name-required' | translate }}
        </mat-error>
      </mat-form-field>

      <mat-form-field class="flex__child--auto">
        <input
          matInput
          agrNumber
          [step]="0.0001"
          placeholder="{{ 'barn-item.area' | translate }}"
          formControlName="surfaceArea"
          data-test="barn-item__surface-area"
        />
        <span matTextSuffix>m2</span>
        <mat-error *ngIf="barnForm.controls.surfaceArea.invalid">
          {{ 'barn-item.error-surface-area' | translate }}
        </mat-error>
      </mat-form-field>

      <mat-form-field class="flex__child--auto">
        <input
          matInput
          placeholder="{{ 'barn-item.animal-group-barn-id' | translate }}"
          formControlName="animalGroupBarnIdsInput"
          data-test="barn-item__animalGroupBarnIds"
        />
      </mat-form-field>

      <div class="spacing--margin-top mat-button-row">
        <button
          type="submit"
          mat-flat-button
          class="flex__child"
          color="primary"
          data-test="barn-item__save"
        >
          {{ 'save' | translate }}
        </button>
        <button
          mat-stroked-button
          color="primary"
          data-test="barn-item__add-cancel"
          type="button"
          (click)="cancel()"
        >
          {{ 'cancel' | translate }}
        </button>
      </div>
    </div>
  </form>
</div>
